module.exports = __webpack_public_path__ + "fonts/AftaSansThin-Regular.76078acf.otf";